module.exports = __webpack_public_path__ + "static/media/21ECLAC20.dd104950.jpg";